// cupData.js

// 32개 이미지 import (artist1 ~ artist32)
// 실제 파일 경로에 맞춰 수정하세요!
import artist1Img from "@/assets/img/artist/resize/Communication-lacking Artist.webp";
import artist2Img from "@/assets/img/artist/resize/Language-Barrier Artist.webp";
import artist3Img from "@/assets/img/artist/resize/Technically-Uninformed Artist.webp";
import artist4Img from "@/assets/img/artist/resize/Poor-Planning Artist.webp";
import artist5Img from "@/assets/img/artist/resize/Unclear-Goal Artist.webp";
import artist6Img from "@/assets/img/artist/resize/One-Way Directive Artist.webp";
import artist7Img from "@/assets/img/artist/resize/Creativity-Conflict Artist.webp";
import artist8Img from "@/assets/img/artist/resize/Decision-Delaying Artist.webp";
import artist9Img from "@/assets/img/artist/resize/Role-Intruding Artist.webp";
import artist10Img from "@/assets/img/artist/resize/Rigid Communication-Style Artist.webp";
import artist11Img from "@/assets/img/artist/resize/Time-Mismanaging Artist.webp";
import artist12Img from "@/assets/img/artist/resize/Scope-Creep Artist.webp";
import artist13Img from "@/assets/img/artist/resize/Budget-Ignorant Artist.webp";
import artist14Img from "@/assets/img/artist/resize/Quality-Neglecting Artist.webp";
import artist15Img from "@/assets/img/artist/resize/Risk-Blind Artist.webp";
import artist16Img from "@/assets/img/artist/resize/Poor-Team-Management Artist.webp";
import artist17Img from "@/assets/img/artist/resize/Inexperienced Artist.webp";
import artist18Img from "@/assets/img/artist/resize/Knowledge-Sharing-Neglect Artist.webp";
import artist19Img from "@/assets/img/artist/resize/Feedback-Ignoring Artist.webp";
import artist20Img from "@/assets/img/artist/resize/No-Shared-Vision Artist.webp";
import artist21Img from "@/assets/img/artist/resize/Technology-Distrusting Artist.webp";
import artist22Img from "@/assets/img/artist/resize/Collaboration-Tool-Avoiding Artist.webp";
import artist23Img from "@/assets/img/artist/resize/Over-Perfectionist Artist.webp";
import artist24Img from "@/assets/img/artist/resize/Credit-Hogging Artist.webp";
import artist25Img from "@/assets/img/artist/resize/Responsibility-Dodging Artist.webp";
import artist26Img from "@/assets/img/artist/resize/Emotionally-Overreacting Artist.webp";
import artist27Img from "@/assets/img/artist/resize/Overly-Tech-Reliant Artist.webp";
import artist28Img from "@/assets/img/artist/resize/Unrealistic-Deadline Artist.webp";
import artist29Img from "@/assets/img/artist/resize/Art-Idea-Obsessed Artist.webp";
import artist30Img from "@/assets/img/artist/resize/Ignoring-Client-Needs Artist.webp";
import artist31Img from "@/assets/img/artist/resize/Collaboration-Burnout Artist.webp";
import artist32Img from "@/assets/img/artist/resize/Failure-to-Adapt Artist.webp";


export const artistData = [
    {
      name: "대화 단절로 협업이 삐걱!\n소통 부재형 예술가",
      img: artist1Img,
      desc: "기술 팀과 원활히 의사소통하지 않는 예술가이다. 자신의 아이디어나 요구사항을 제대로 전달하지 않거나 기술자의 설명을 경청하지 않아 협업에 혼선을 초래한다. 이러한 소통 결여는 오해와 불신을 낳아 프로젝트 실패의 단초가 된다.",
    },
    {
      name: "전문용어의 미로에서 길 잃은\n언어 장벽형 예술가",
      img: artist2Img,
      desc: "예술적 전문용어만 사용하여 기술자와의 공통 언어를 형성하지 못하는 유형이다. 예술가와 기술자가 “서로 다른 언어를 쓰는 느낌”이 들 정도로 용어 간 격차가 크면 협업이 어려워진다. 연구에서도 공유 언어 부족이 초기 협업의 큰 장애요인으로 지적된다.",
    },
    {
      name: "기술에 대한 이해 제로,\n기술 이해 부족형 예술가",
      img: artist3Img,
      desc: "기술적 한계와 구현 현실을 잘 모르는 예술가로, 비현실적인 요구를 한다. 예를 들어 대형 공공 미디어아트 설치를 계획하면서 예산, 안전, 기술적 난이도를 전혀 파악하지 못하는 경우가 있다. 기술적 이해 부족으로 실행 불가능한 아이디어를 추구하면 프로젝트가 추진 단계부터 좌초될 수 있다.",
    },
    {
      name: "계획 없이 출항!\n사전 계획 부실형 예술가",
      img: artist4Img,
      desc: "프로젝트 계획과 준비가 부족한 유형이다. 작품의 규모나 일정, 비용, 인허가 등을 면밀히 따지지 않고 막연한 구상만 하는 경우가 이에 해당한다. 한 사례에서 예술가는 거대 조형물을 구상했지만 예산 확보, 관련 규제 검토, 기술 인력 준비가 전혀 없이 시작하여 문제를 야기했다. 치밀한 사전 계획 없는 협업은 진행 중 잦은 차질을 빚는다.",
    },
    {
      name: "왜 만드는지조차 모르는\n목표 불명확형 예술가",
      img: artist5Img,
      desc: "프로젝트의 목적이나 메시지가 모호한 예술가로, 팀원들에게 명확한 방향을 제시하지 못한다. 협업 초기에 작품의 예술적 목표를 명확히 공유하지 않으면 기술자 입장에서도 무엇을 우선해야 할지 혼란스럽다. 결과적으로 산출물이 지향점 없이 방황하게 되어 완성도 저하나 의도 미달로 실패하기 쉽다.",
    },
    {
      name: "기술자는 들러리?\n일방향 지시형 예술가",
      img: artist6Img,
      desc: "협업을 대등하게 여기지 않고 기술자를 보조 인력처럼 일방적으로 부리는 유형이다. 기술적 난관이나 아이디어 개선점에 대해 대화하기보다 지시만 내리면, 기술자는 수동적으로 변하고 창의적 기여를 포기하게 된다. 이로 인해 팀 시너지가 떨어지고 갈등이 심화되어 결과물이 기대에 못 미치게 된다.",
    },
    {
      name: "타협 없이 부딪치는\n창의성 충돌 유발형 예술가",
      img: artist7Img,
      desc: "협업자와 창의적 비전이 충돌할 때 유연하게 조율하지 못하고 갈등을 키우는 예술가이다. 예술적 컨셉을 고집한 나머지 기술자의 아이디어를 배척하거나, 반대로 기술 구현상의 제약에 과민 반응하여 다투는 경우가 이에 속한다. 실제 사례에서도 디자이너(예술가)가 충분히 탐구를 하고 있지 못한 상태에서 엔지니어는 개발을 서두르고, 서로 “상대방 때문에 막힌다”는 좌절감을 표현하기도 한다. 이런 창의성 충돌을 해결하지 못하면 협업이 파국으로 치닫는다.",
    },
    {
      name: "“조금만 더 고민해볼게…”\n의사결정 지연형 예술가",
      img: artist8Img,
      desc: "중요한 결정이나 피드백을 제때 주지 않는 예술가로, 프로젝트 진행을 지체시킨다. 특히 디자인 방향이나 콘텐츠 확정에 시간이 걸려 개발팀이 착수하지 못하는 경우가 여기에 해당한다. 사례에 따르면, 디자이너가 여러 아이디어를 실험하느라 최종 방향 결정을 미루면 엔지니어는 작업 시작이 막혀 답답함을 느끼게 된다. 이런 지연이 누적되면 일정 압박이 커지고 완성도와 사기가 떨어진다.",
    },
    {
      name: "기술 영역까지 넘보는\n역할 침범형 예술가",
      img: artist9Img,
      desc: "자신의 전문 분야를 넘어 기술 구현에 지나치게 간섭하거나 통제하려는 예술가이다. 예술가가 코딩 세부사항까지 지시하거나 기술 선택을 독단적으로 결정하면, 전문 기술자의 역할을 침해하여 팀워크에 금이 간다. 서로의 전문성을 존중하며 “춤추듯 역할을 주고받아야” 하는 협업에서, 한쪽이 타인의 영역까지 억지로 끌고 가면 마찰과 비효율을 초래한다.",
    },
    {
      name: "자기 방식만 고집하는\n소통 스타일 경직형 예술가",
      img: artist10Img,
      desc: "기술자에게 자기 방식의 소통만 강요하고 상대방의 커뮤니케이션 방식에 적응하지 않는 유형이다. 예를 들어 지나치게 예술적인 비유로만 설명하여 기술자가 이해하지 못하거나, 기술자의 전문어 사용을 끝까지 이해하려 노력하지 않는 식이다. 한 연구자는 협업 초기에 “예술가와 내가 서로 다른 언어를 쓰는 듯했다”고 회고하는데, 이러한 상황에서 예술가가 소통 방식을 조율하지 않으면 이해 격차가 좁혀지지 않아 협업이 난항을 겪는다.",
    },
    {
      name: "마감을 모르고 사는\n시간 관리 실패형 예술가",
      img: artist11Img,
      desc: "일정 준수에 소홀한 예술가이다. 영감이나 창의성을 이유로 마감 기한을 놓치거나, 계획된 일정보다는 즉흥적 작업에 치중하여 프로젝트 타임라인이 어그러지는 경우가 이에 속한다. 프로젝트 일정 관리는 성공적 협업의 핵심 요소로 꼽히며, 이를 무시하면 다른 팀원의 작업도 연쇄적으로 지연되고 최종 마감에 차질을 빚는다.",
    },
    {
      name: "끝없이 욕심내는\n범위 관리 실패형 예술가",
      img: artist12Img,
      desc: "프로젝트 범위를 통제하지 못하는 유형으로, 이른바 스코프 크립(Scope Creep)을 유발하는 예술가다. 프로젝트 중간에 욕심이 생겨 계획에 없던 새로운 기능이나 표현을 계속 추가하려 들면, 프로젝트 범위 관리에 실패하게 되고, 이는 예산과 일정 초과로 직결되어 협업이 실패할 위험이 높아진다.",
    },
    {
      name: "돈 계산은 뒷전!\n예산 감각 부족형 예술가",
      img: artist13Img,
      desc: "현실적인 비용 감각이 부족하여 예산을 초과하거나 자원을 비효율적으로 사용하는 예술가다. 기술 구현에 드는 비용을 고려하지 않고 구상을 변경하거나, 후반에 추가 지출을 요구하는 경우 팀에 큰 부담을 준다. 프로젝트 비용 관리 능력이 결여되면 협업은 지속 가능성을 잃고 중도에 좌초될 가능성이 높다.",
    },
    {
      name: "예술기술의 균형과 완성도를 놓쳐버린\n품질 관리 소홀형 예술가",
      img: artist14Img,
      desc: "작품의 완성도와 기술적 품질 균형을 관리하지 못하는 예술가다. 예를 들어 미적 요소에만 몰두하고 안정성 검증이나 오류 수정에는 관심이 없거나, 반대로 기술 구현에만 의존하고 예술적 완성도를 놓치는 경우다. 협업에서 예술적 품질과 기술적 품질 둘 다 중요하지만, 이를 균형 있게 챙기지 못하면 최종 결과물이 미흡해진다. 실제로 한 AR 아트 협업에서는 연구자인 기술자가 1cm 단위 정밀도에 집착하고, 예술가는 시스템이 공연 중 멈추지 않을 안정성을 더 중시하여 초점 차이가 드러났다.",
    },
    {
      name: "위험도 즐기는(?)\n위험 관리 미흡형 예술가",
      img: artist15Img,
      desc: "기술적·운영상의 리스크를 간과하는 예술가다. 새로운 기술을 도입하면서 백업 플랜을 세우지 않거나, 공연 직전에 대규모 수정 같은 위험한 결정을 내리는 경우가 있다. 협업 연구에서는 체계적인 위험 관리가 성공 요인으로 강조되는데, 이를 무시하면 작은 문제가 치명적 실패로 번질 수 있다.",
    },
    {
      name: "팀 갈등을 부추기는\n인력 관리 미숙형 예술가",
      img: artist16Img,
      desc: "협업 팀 구성원들의 역할 분담과 사기 관리에 실패하는 예술가다. 적합한 기술 파트너를 찾지 못하거나, 팀원 간 갈등을 중재하지 못해 분열을 초래하는 경우가 이에 속한다. 프로젝트 리더로서 인원 관리 역량이 부족하면 기술자와의 협업 분위기가 나빠지고 결국 목표 달성이 어려워진다.",
    },
    {
      name: "첫걸음부터 헤매는\n경험 부족형 예술가",
      img: artist17Img,
      desc: "다분야 협업 경험이 적어 시행착오를 반복하는 초심자 유형이다. 특히 신진 미디어 아티스트의 경우 기술자와의 협업 프로세스를 잘 몰라 초기 “인지적 혼란(cognitive blur)” 상태를 겪기도 한다. 이런 경우 협업 절차를 익히는 데 시간이 걸리고, 숙련된 파트너의 가이드가 없으면 협업 진척이 더디거나 실패하기 쉽다.",
    },
    {
      name: "배우려 하지 않는\n지식 공유 태만형 예술가",
      img: artist18Img,
      desc: "기술과 프로젝트 진행에 대한 학습 노력이나 지식 공유를 게을리하는 예술가다. 새로운 매체나 도구에 대해 기본적인 이해를 얻으려 하지 않으면 협업 효율이 떨어진다. 또한 본인의 예술적 의도나 콘텐츠 정보를 기술자와 충분히 공유하지 않으면 결과물이 엇나갈 수 있다. 협업 과정에서 필요한 요소들을 충분히 이해하고자 하는 태도가 부족하면 의사소통 오류와 시행착오가 증가하여 결과적으로 실패 확률이 높아진다.",
    },
    {
      name: "피드백 문을 걸어잠그는\n피드백 무시형 예술가",
      img: artist19Img,
      desc: "청중이나 동료로부터의 피드백에 무관심한 예술가다. 작품 발표 후 관객 반응이나 사용자 테스트 결과를 수집하지 않거나, 기술자나 동료의 개선 제안을 듣지 않는다면 작품의 결함을 놓치게 된다. 한 연구 사례에서 예술가들은 작품 전시 후 “메시지가 관객에게 전달됐는지” 등에 관심이 적어 피드백을 거의 수렴하지 않았고, 이는 연구자인 기술자에게 의아한 점으로 지적되었다. 이러한 태도는 작품 완성도를 높일 기회를 잃고 동일한 실수를 반복하게 만들어 협업 성과를 떨어뜨린다.",
    },
    {
      name: "목적지도 없이 출항한\n공유 비전 부재형 예술가",
      img: artist20Img,
      desc: "기술자와 처음부터 최종 목표에 대한 비전을 공유하지 않는 예술가다. 성공적인 창의 협업은 “공통 목표에 대한 대화”를 통해 여러 사람의 관점을 연결함으로써 가능하다는 지적이 있다. 예술가가 협업 초기에 자신의 예술적 비전과 프로젝트 목표를 기술진과 함께 충분히 정의하지 않으면, 각자 다른 방향을 향해 노력하게 되어 협업 결과물이 통일성을 잃고 실패 위험이 커진다.",
    },
    {
      name: "기술 불신의 벽을 쌓은\n기술 불신형 예술가",
      img: artist21Img,
      desc: "기술이나 기술자에 대한 신뢰가 부족하여 협업에 마음을 열지 않는 예술가다. 이들은 첨단 기술을 예술의 적으로 여기거나, 기술자가 예술적 가치를 훼손할 거라는 선입견을 가지고 있어서 적극적인 협력을 꺼린다. 예술과 기술 두 분야 사이의 오랜 간극으로 인해 서로를 폄하하거나 두려워하는 태도는 협업을 어렵게 만드는 요인이다. 예술가가 기술 전문가를 신뢰하지 못하면 정보 공유와 의사결정이 원활히 이루어지지 않아 프로젝트가 진전되지 않는다.",
    },
    {
      name: "디지털 협업툴은 딴 세상?\n협업 도구 회피형 예술가",
      img: artist22Img,
      desc: "프로젝트 관리나 협업 도구 사용을 기피하는 예술가다. 예를 들어 이슈 트래커나 버전 관리 시스템, 온라인 협업 플랫폼 사용에 비협조적이면 팀 협업 효율이 떨어진다. 기술자는 최신 툴로 소통하고자 하는데 예술가가 이를 따르지 않으면 정보가 누락되거나 업무가 병목된다. 시대에 맞는 정보 교환 플랫폼 활용은 협업 기반 조성의 한 요소인데, 이를 거부하는 태도는 팀원 간 발맞추기를 어렵게 해 실패를 초래할 수 있다.",
    },
    {
      name: "타협 모르는 완벽 추구!\n과도 완벽주의형 예술가",
      img: artist23Img,
      desc: "완벽한 결과만을 추구하느라 실용적 타협을 못하는 예술가다. 작품의 세부 요소 하나까지 완벽하지 않으면 넘어가지 못해 일정 지연이나 과업 과부하를 부른다. 제품/서비스 디자인 맥락에서도 디자이너는 출시 전에 사용자 경험을 충분히 가다듬길 원하고, 엔지니어는 일단 기능을 구현해 빠르게 공개하고 싶어하는 차이가 있다. 이처럼 예술가가 완벽만을 고집하면 기술 측의 기능 구현/출시 우선 순위와 충돌하여 마찰이 생기고, 결과적으로 기한 내 프로젝트 완수를 못하거나 비용 초과로 실패할 수 있다.",
    },
    {
      name: "공로 독차지!\n성과 독식형 예술가",
      img: artist24Img,
      desc: "협업 결과에 대한 공로를 독차지하려는 예술가다. 공동 작업에서 나온 산출물을 자신의 예술적 성취로만 포장하고 기술 기여를 외부에 인정하지 않으면 팀 사기는 크게 떨어진다. 더 심각한 경우, 작품의 지적재산권(IP)이나 저작권 문제로 분쟁이 생길 수 있다. 이종 분야 협업에서는 IP에 대한 인식 차이로 갈등이 발생하기 쉽다고 지적되며, 실제로 예술가와 기술자 간에 작품 소유권이나 크레딧 표기 문제로 불화가 생겨 협업 관계가 틀어지는 사례도 보고된다.",
    },
    {
      name: "‘네 탓’만 외치는\n책임 회피형 예술가",
      img: artist25Img,
      desc: "문제가 생겼을 때 자신의 책임을 인정하지 않고 모두 기술적 실패로 돌리는 유형이다. 프로젝트 지연, 작품 구현 미흡 등이 발생하면 협업 특성상 쌍방의 원인이 있을 수 있는데, 이를 조율하기보다는 예술가는 “기술자가 제대로 못 해서”라고 탓만 하게 되면 팀 내 불신이 커진다. 이러한 책임 전가 행태는 갈등을 증폭시키고 건설적인 문제 해결을 가로막아 프로젝트를 위험에 빠뜨린다.",
    },
    {
      name: "감정 먼저 폭발하는\n감정적 대응형 예술가",
      img: artist26Img,
      desc: "협업 중 피드백이나 충고에 감정적으로 반응하여 팀 분위기를 해치는 예술가다. 기술자가 구현상의 어려움을 설명하거나 수정 제안을 하면 개인적 비판으로 받아들여 격앙된 대응을 보이는 경우, 기술자는 더 이상 솔직한 의견을 내기 어려워지고 의사소통이 단절된다. 예술적 작업에 애착이 큰 것은 자연스럽지만, 감정을 조율하지 못하면 팀 전체 사기에 악영향을 끼쳐 협업 성과를 망칠 수 있다.",
    },
    {
      name: "문제 해결보다 최신 기술만 좇는\n기술 의존 과도형 예술가",
      img: artist27Img,
      desc: "예술적 문제를 창의적으로 해결하기보다 기술에만 의지하려는 예술가다. 새로운 표현을 고민하기보다 “최신 기술이 해결해주겠지” 하고 막연히 기대하거나, 작품의 예술적 콘셉트보다는 어떤 기술을 쓸지가 우선이 되는 경우다. 그러나 기술 자체에 치중하면 정작 기술이 예상대로 작동하지 않을 때 대안을 마련하지 못해 실패할 위험이 있다. 기술은 도구일 뿐 본질이 아님을 간과하면 결과물이 기술 데모 수준에 머물고 예술적 완성도는 낮아질 수 있다.",
    },
    {
      name: "“빨리빨리!” 무리한 속도전\n비현실적 일정 요구형 예술가",
      img: artist28Img,
      desc: "기술 구현에 필요한 시간은 무시한 채 무리한 속도를 요구하는 예술가다. 예술가는 영감에 따라 늦게 요구사항을 확정하면서도 결과물은 정해진 일정 내 나오길 바라거나, “이 정도쯤이야 빨리 해달라”고 기술팀을 압박할 수 있다. 이는 기술자에게 과중한 부담을 주고 결과적으로 품질 저하나 개발자 번아웃을 야기해 프로젝트 실패 확률을 높인다.",
    },
    {
      name: "절대 양보 없는\n창작물 집착형 예술가",
      img: artist29Img,
      desc: "자신의 예술적 산출물에만 집착하여 기술적 구현상의 필요에 융통성을 보이지 않는 유형이다. 예술적 아이디어를 현실화하는 과정에서 일부 변경이나 타협이 불가피할 때, 이를 한사코 거부하면 교착 상태에 빠진다. 예를 들어 특정 효과 구현이 어려워 대안을 제시해도 “내 작품을 훼손하지 말라”며 받아들이지 않으면 기술자는 진행을 멈출 수밖에 없다. 이러한 융통성 부족은 협업을 막다른 길로 몰아넣는다.",
    },
    {
      name: "후원사·클라이언트 뒷전\n외부 요구 무시형 예술가",
      img: artist30Img,
      desc: "후원사나 클라이언트의 요구사항을 무시하거나 잊는 예술가다. 작품 의도에만 몰두한 나머지 협업 프로젝트의 의뢰 목적이나 스폰서의 피드백을 간과하면, 최종 산출물이 기대와 어긋나게 된다. 이는 신뢰 관계 훼손과 지원 중단으로 이어질 수 있어 프로젝트 지속성에 치명적이다.",
    },
    {
      name: "중도 탈주로 팀 붕괴!\n협업 피로형 예술가",
      img: artist31Img,
      desc: "긴 협업 과정에 지쳐 중도에 참여도가 급격히 떨어지는 예술가다. 예술 분야 종사자는 보통 개인 작업 리듬에 익숙한데, 장기간 팀 프로젝트에 참여하면서 피로와 스트레스를 느껴 투입을 줄이거나 의사소통을 끊기도 한다. 이처럼 끝까지 일관된 참여를 하지 못하면 남은 팀이 그 공백을 메워야 하고, 예술적 의사결정이 제때 이루어지지 않아 프로젝트 완결이 어려워질 수 있다.",
    },
    {
      name: "변화의 바람을 거부하는\n변화 대응 실패형 예술가",
      img: artist32Img,
      desc: "프로토타입 테스트나 기술적 제약 등으로 인한 방향 수정에 적응하지 못하는 예술가다. 협업에서는 초기 계획에서 일정 부분 변화가 생길 수 있는데, 예술가가 융통성 있게 콘셉트 또는 디자인을 조정하지 못하면 팀 전체 진행이 막히게 된다. 변화는 창작 프로세스의 일부인데 이를 받아들이지 못하면 협업 성과물이 환경 변화에 부응하지 못하고 실패하게 된다.",
    },
  ];
